module.exports = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="647px" height="121px"  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
    <title>Artboard 15</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Artboard-15" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Activation-Process-Illo" transform="translate(-11.000000, 0.000000)">
    
            <g id="Group-4" transform="translate(39.000000, 0.000000)">
                <circle id="Oval-2-Copy" stroke="#D3D8DE" fill-rule="nonzero" cx="151" cy="14" r="12"></circle>
                <circle id="Oval-2-Copy-2" stroke="#D3D8DE" fill-rule="nonzero" cx="290" cy="14" r="12"></circle>
                <circle id="Oval-2-Copy-3" stroke="#D3D8DE" fill-rule="nonzero" cx="429" cy="14" r="12"></circle>
                <circle id="Oval-2-Copy-4" stroke="#D3D8DE" fill-rule="nonzero" cx="568" cy="14" r="12"></circle>
                <g id="check-circle-08" fill-rule="nonzero">
                    <path d="M12,24 C5.38298087,24 0,18.6167635 0,12 C0,5.38323652 5.38298087,0 12,0 C18.6170191,0 24,5.38323652 24,12 C24,18.6167635 18.6170191,24 12,24 Z" id="Shape" fill="#72C472"></path>
                    <polygon id="Shape" fill="#FFFFFF" points="9.91304348 17.6497096 4.26358957 12 5.73913043 10.5242035 9.91304348 14.6981165 18.2608696 6.35029043 19.7364104 7.82608696"></polygon>
                </g>
                <g id="Group" transform="translate(28.000000, 6.000000)" stroke="#D3D8DE" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                    <g id="Group-5" transform="translate(53.500000, 6.257385) rotate(-180.000000) translate(-53.500000, -6.257385) translate(0.500000, 0.757385)">
                        <polyline id="Stroke-1" points="5.7585 10.75 0.7585 5.75 5.7585 0.75"></polyline>
                        <path d="M2,5.75 L105,5.75" id="Stroke-3"></path>
                    </g>
                </g>
                <g id="Group-Copy" transform="translate(167.000000, 6.000000)" stroke="#D3D8DE" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                    <g id="Group-5" transform="translate(53.500000, 6.257385) rotate(-180.000000) translate(-53.500000, -6.257385) translate(0.500000, 0.757385)">
                        <polyline id="Stroke-1" points="5.7585 10.75 0.7585 5.75 5.7585 0.75"></polyline>
                        <path d="M2,5.75 L105,5.75" id="Stroke-3"></path>
                    </g>
                </g>
                <g id="Group-Copy-2" transform="translate(306.000000, 6.000000)" stroke="#D3D8DE" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                    <g id="Group-5" transform="translate(53.500000, 6.257385) rotate(-180.000000) translate(-53.500000, -6.257385) translate(0.500000, 0.757385)">
                        <polyline id="Stroke-1" points="5.7585 10.75 0.7585 5.75 5.7585 0.75"></polyline>
                        <path d="M2,5.75 L105,5.75" id="Stroke-3"></path>
                    </g>
                </g>
                <g id="Group-Copy-3" transform="translate(445.000000, 6.000000)" stroke="#D3D8DE" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                    <g id="Group-5" transform="translate(53.500000, 6.257385) rotate(-180.000000) translate(-53.500000, -6.257385) translate(0.500000, 0.757385)">
                        <polyline id="Stroke-1" points="5.7585 10.75 0.7585 5.75 5.7585 0.75"></polyline>
                        <path d="M2,5.75 L105,5.75" id="Stroke-3"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;
